import { AdminLeadControllerGetAllResponse } from "service";
import FilterRow from "@/shared/components/FilterRow";
import { FilterState, UpdateFilter } from "../hooks/useLeadsFilters";
import LeadsBulkActions from "./LeadsBulkActions";

interface LeadsFiltersProps {
  filters: FilterState;
  updateFilter: UpdateFilter;
  onSearch: (search: string) => void;
  isLoading: boolean;
  data: AdminLeadControllerGetAllResponse | undefined;
}

const LeadsFilters = ({
  filters,
  updateFilter,
  onSearch,
  isLoading,
  data,
}: LeadsFiltersProps) => {
  const tablePaginationProps = {
    limit: filters.limit,
    page: filters.page,
    isLoading,
    count: data?.metaData?.count ?? 0,
    setToPage: (page: number) => updateFilter("page", page),
    setLimit: (limit: number) => updateFilter("limit", limit),
  };

  return (
    <FilterRow
      bulkActions={
        <LeadsBulkActions
          leadIds={filters.selectedLeadIds}
          resetSelections={() => updateFilter("selectedLeadIds", [])}
        />
      }
      tablePaginationProps={tablePaginationProps}
      search={filters.search}
      onSearchChanged={onSearch}
    />
  );
};

export default LeadsFilters;
